(function($){
  $(document).ready(function(){

    // Initialized from global.js

  });
})(jQuery);

function shopifyFormInit($form){
  if ( !$form.hasClass('shopify-form-processed')) {

    $form.find('textarea[name="custom#trew_part_number_and_quantity"]').each(function() {
      const $t = $(this);
      if ( !$t.hasClass('shopify-form-processed')) {
        const t = new RMAList($t);
      }
    });

    $form.addClass('shopify-form-processed');
  }
}

class RMAList {

  constructor($input){
    const _this = this;

    this.$input = $input;
    this.$inputWrap = this.$input.closest('div');
    this.$wrap = $('<div class="rma-list-wrap"></div>');
    this.$wrap.insertBefore(this.$inputWrap);
    this.$inputWrap.hide();

    this.$form = this.$input.closest('form');
    this.rows = 1;

    this.draw();

    this.$form.on('click', '.rma-actions .as-b', function(e) {
      _this.rows += 1;
      _this.draw();
    });

    this.$form.on('change keydown keyup', '.rma-list-wrap input', function(e) {
      _this.valueUpdate();
    });
    // this.$form.on('blur', '.rma-list-wrap input', function(e) {
    //   _this.$input.focus();
    //   _this.$input.blur();
    //   _this.$input.trigger('change');
    // });

    this.$input.addClass('shopify-form-processed');
  }

  valueUpdate() {
    let vals = [];
    this.$wrap.find('.rma-row').each(function() {
      const $r = $(this);
      const $i_tpn = $r.find('.rma-input-tpn');
      if ( $i_tpn.val()) {
        $i_tpn.parent().find('label').addClass('filled');
      } else {
        $i_tpn.parent().find('label').removeClass('filled');
      }

      const $i_qty = $r.find('.rma-input-qty');
      if ( $i_qty.val()) {
        $i_qty.parent().find('label').addClass('filled');
      } else {
        $i_qty.parent().find('label').removeClass('filled');
      }

      const val = 'TPN: '+$i_tpn.val()+' QTY: '+$i_qty.val();
      vals.push(val);
    });
    this.$input.val(vals.join(" \n"));
    this.$input.get(0).dispatchEvent(new Event('input', { bubbles: true }));
  }

  draw() {
    for (let i = 1; i <= this.rows; i++) {
      let $r = this.$form.find('.rma-row[data-i="'+i+'"]');
      if ( !$r.length ) {
        $r = $('<div class="rma-row row" data-i="'+i+'"></div>');
        const $tw = this.$wrap.closest('form').find('#first_name').closest('div');
        this.$wrap.append($r);
        $r.html('<div class="col col--8">' +
          '</div>' +
          '<div class="col col--4">' +
          '</div>');
        const $i1 = $tw.clone();
        $i1.find('label').html('Trew Part Number');
        $i1.find('input').attr('id', '').addClass('rma-input-tpn').data('testid', '').val('');
        $r.find('.col--8').append($i1);
        const $i2 = $tw.clone();
        $i2.find('label').html('Quantity');
        $i2.find('input').attr('id', '').addClass('rma-input-qty').data('testid', '').val('');
        $r.find('.col--4').append($i2);
      }
    }

    let $ra = this.$form.find('.rma-actions');
    if ( !$ra.length ) {
      $ra = $('<div class="rma-actions">' +
        '<span class="as-b">Add More Parts</button>' +
        '</div>');
      $ra.insertBefore(this.$inputWrap);
    }
  }

}
